import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks/storeHooks';
import FieldProductionChart from './FieldProductionChart';
import './FieldProduction.scss';
import { fetchFieldProduction, selectFieldProduction, selectFieldProductionLoading } from '../WellSummaryDashboardSlice';
import FullScreenIcon from '../../common/FullScreenIcon/FullScreenIcon';
import DownloadChart from '../../../components/time-series-chart/download/downloadChart';
import { ReactComponent as CloseIcon } from '../../../images/close-x-icon.svg';
import { downloadChartUtil } from '../../../utilities/ExportChart';
import Loader from '../../common/Loader/Loader';
import EmptyState from '../../../components/empty-state/EmptyState';

const FieldProduction: React.FC = () => {
  const dispatch = useAppDispatch();
  const data = useAppSelector(selectFieldProduction);
  const isLoading = useAppSelector(selectFieldProductionLoading);
  const [fullScreen, setFullScreen] = useState<boolean>(false);
  useEffect(() => {
    dispatch(fetchFieldProduction({}));
  }, [dispatch]);
  const handleFullscreen = () => {
    setFullScreen(true);

    setTimeout(() => {
      const fullscreenModal = document.querySelector('.fullscreen-modal');
      if (fullscreenModal && !document.fullscreenElement) {
        fullscreenModal.requestFullscreen().catch((err) => {
          console.error(`Error attempting to enable fullscreen: ${err.message}`);
        });
      }
    }, 0);
  };
  const handleCloseFullscreen = () => {
    setFullScreen(false);

    // Exit fullscreen mode if active
    if (document.fullscreenElement) {
      document.exitFullscreen().catch((err) => {
        console.error(`Error attempting to exit fullscreen: ${err.message}`);
      });
    }
  };
  const handleChartDownload = (option: string) => {
    const fileName = 'Field production (By MOP)_TimeSeriesChart';
    const header = `Field production (By MOP)`;
    let element: HTMLElement | null;
    if (fullScreen) {
      element = document.getElementById('fullscreen-chart-container');
    } else {
      element = document.getElementById(`fop-chart-container`);
    }
    downloadChartUtil(option, fileName, element, header);
  };
  const hasData = data.length && data.some((item) => item.coordinates.length);
  return (
    <>
      <div className='field-production-container'>
        <div className='title'>
          Field production (By MOP)
          <div className='fop-chart-controls'>
            <button className='chart-action-button' onClick={() => handleFullscreen()}>
              <FullScreenIcon />
            </button>
            <div className='chart-action-button'>
              <DownloadChart onClick={(option) => handleChartDownload(option)} canExportJpg={true} canExportPdf={true} />
            </div>
          </div>
        </div>

        <div className='wsw-divider' />
        {isLoading ? (
          <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
            <Loader />
          </div>
        ) : hasData ? (
          <FieldProductionChart rawData={data} fullscreen={fullScreen} />
        ) : (
          <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
            <EmptyState message='No data available' />
          </div>
        )}
      </div>
      {/* Fullscreen Modal */}
      {fullScreen && (
        <div className='fullscreen-modal'>
          <div className='fullscreen-header'>
            <div className='fullscreen-header-components'>
              <span className='fullcreen-header-content'>Field production (By MOP)</span>
              <button
                analytics-id='fullscreen-modal-close-btn'
                className='close-button'
                onClick={handleCloseFullscreen}
              >
                <CloseIcon />
              </button>
            </div>
            <div className='min-max flex justify-between items-center gap-[15px]'>
              <div className='chart-action-button'>
                <DownloadChart onClick={(option) => handleChartDownload(option)} canExportJpg={true} canExportPdf={true} />
              </div>
            </div>
          </div>
          <div id='fullscreen-chart-container' className='fullscreen-chart-container'>
            {hasData ? (
              <FieldProductionChart rawData={data} fullscreen={fullScreen} />
            ) : (
              <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
                <EmptyState message='No data available' />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
export default FieldProduction;
